export enum StorageKeysEnum {
    preauthorizeToken = 'net2beeple-preauthorizeToken',
    preauthorizeTokenExpirationTime = 'net2beeple-preauthorizeTokenExpirationTime',
    accessToken = 'net2beeple-accessToken',
    accessTokenExpirationTime = 'net2beeple-accessTokenExpirationTime',
    refreshToken = 'net2beeple-refreshToken',
    refreshTokenExpirationTime = 'net2beeple-refreshTokenExpirationTime',
    user = 'net2beeple-USER',
    uuid = 'net2beeple-uuid',
    company = 'net2beeple-COMPANY',
    settings = 'net2beeple-SETTINGS',
    genericMessages = 'net2beeple-genericMessages',
    timeFormat = 'net2beeple-timeFormat'
}
